import {
    POST_CARGAR_ARCHIVO_ANALYTIC,
    GET_INFO_CARGA_ANALYTIC_PREVIO,
    GET_INFO_ERRORES_CARGA_ANALYTIC
} from '../types';

export default function cargaCasosAnalyticReducer(state = {}, action) {
    switch (action.type) {        
        case POST_CARGAR_ARCHIVO_ANALYTIC:
            return { ...state, archivo: action.payload }
        case GET_INFO_CARGA_ANALYTIC_PREVIO:
            return { ...state, infoCargaAnalyticPrevio: action.payload }       
        case GET_INFO_ERRORES_CARGA_ANALYTIC:
            return { ...state, infoErroresCargaAnalytic: action.payload }       
        default:
            return state
    }
}